/**
 * Unbind `target` event `eventName`'s callback `listener`.
 */
export default function on(target, eventName, listener, options) {
  if (options === void 0) {
    options = false;
  }

  target.removeEventListener(eventName, listener, options);
}